import React, { Component } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import Moment from'moment';
import './adminModelPop.css'
import { userActions } from '../../../actions/index.js';
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

const initialState={
  
}
class AdminDeletePopup extends Component {

constructor(props) {
  super(props);
  this.state = initialState
}
close = () => {
    this.props.close()
};
delete = (e) => {
    this.props.dispatch(userActions.deleteAuditor("/auditorData/delete/" + this.props.selectedEditData.id));
};
componentWillReceiveProps(nextProps) {
    console.log('DeleteProps:',nextProps);
    const reqBody={
        "size":10,
        "index":0,
        "sortColumn":"userId",
        "sortOrder":"ASC"
      }
      if(nextProps.createStatus==="Auditor record deleted successfully"){
        this.props.close();
        confirmAlert({
          title:'Delete Auditor Confirmation alert box',
          message: this.props.createStatus,
          buttons: [
              {
                  label: 'Ok',
                  onClick: () => {
                    this.props.dispatch(userActions.auditorList("/auditorData/auditors",reqBody));
                  }
              },
          ]
      })
}
}
render() {
  return (
    <Modal show={this.props.deleteDialog} onHide={this.close}>
      <Modal.Header closeButton>
        <Modal.Title>
         Delete
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
   Do you want to delete this record?
      </Modal.Body>
      <Modal.Footer>
        <Button className="button" variant="secondary" onClick={this.close}>
          Close
        </Button>
        <Button className="button" variant="secondary" onClick={this.delete}>
          Delete
        </Button>     </Modal.Footer>
    </Modal>
  );
}
}
const mapStateToProps =state =>{
  const {blocking,createStatus}=state.searchData;
  return{
    blocking,createStatus
  }
}
export default withRouter(connect(mapStateToProps)(AdminDeletePopup));
//export default AdminModelPop;